import { stepEnum } from './MochaData'
const env = process.env.NODE_ENV;
const isDevelopment = env === 'development';
const setData: boolean = false;
const InitialPage: number = stepEnum.StepPersonalData;


const getPageInitial = isDevelopment ? InitialPage : 0;

const SiteConfig: ISiteConfig = {
    InitPage: getPageInitial,
    TotalPage: 0,
    TotalPageBar: 5
} as ISiteConfig;

const GetLstBeneficiary = () => {
    return [
        {
            name1: '',
            name2: '',
            lastname1: '',
            lastname2: '',
            identification: '',
            percentage: '',
            relationship: '',
            typeDocument: '1',
            id: 1
        } as IBeneficiary
    ]
}

const GetLstBeneficiaryTest = () => {
    return [
        {
            name1: 'Juan',
            name2: 'Pedro',
            lastname1: 'Juan 2',
            lastname2: ' Pedro 2',
            identification: '',
            percentage: '',
            relationship: '',
            typeDocument: '1',
            id: 1
        } as IBeneficiary,
        {
            name1: 'Juan',
            name2: 'Pedro',
            lastname1: 'Juan 2',
            lastname2: ' Pedro 2',
            identification: '',
            percentage: '',
            relationship: '',
            typeDocument: '1',
            id: 1
        } as IBeneficiary
    ]
}

const VidaDataTemp: IVidaCR = {
    //STEP1
    init: false,
    typeDocument: '',
    identification: '',
    name1: '',
    name2: '',
    lastname1: '',
    lastname2: '',
    birthdate: undefined,
    age: '',
    province: '',
    canton: '',
    district: '',
    neighborhood: '',
    address: '',
    cellPhoneNumber: '',
    email: '',

    nationality: '',
    sex: '',
    profession: '',
    company: '',
    companyPhone: '',
    monthlyIncome: '',
    originFunds: '',
    originFundsExplained: '',
    //STEP2
    plan: '',
    currency: '',
    nQuotas: '',
    nCoverage: {} as ICoveragesPlan,
    lstPlanConfig: [],
    planSelected: '',

    catQuotas: [],
    catProvince: [],
    catCanton: [],
    catDistrict: [],
    catNeighborhood: [],
    catNationality: [],
    catProfession: [],
    catOriginFunds: [],
    catCountry: [],
    catBank: [],
    catInvalidRequirements: [],
    planConfig: {} as IPlanConfig,
    catCoverages: [],
    lstRateResumen: [],
    lstRate: [],
    lstBeneficiary: GetLstBeneficiary(),

    feePay: '',
    cardName: '',
    cardNumber: '',
    cardExpirationDate: '',
    cardCVV: '',


    acceptTerms: false,
    acceptTermsPV: false,
    acceptTermsFinish: false,

    statusAccount: '',
    transactionId: '',
    cnpoliza: '',

    acceptSaveCard: '',
    cardType: '',
    cardCountry: '',
    issuingBank: '',
    acceptCardTerm: false,

    polizaid: '',
    dateEnd: undefined,
    dateInit: undefined,
    oportunity: '',
    oportunityCreated: undefined,
    errorRate: false,
    messageErrorRate: '',

    paymentPV: () => { },
    downloadPolicy: () => { },
    finish: () => { },
    downloadReceipts: () => { },
    viewFinishPage: () => { },
}

const VidaWithDataTemp: IVidaCR = {
    init: false,
    typeDocument: '1',
    identification: '1-1445-0433',
    name1: 'test',
    name2: '',
    lastname1: 'test',
    lastname2: '',
    birthdate: new Date(1991, 5, 5),
    age: '',
    province: '',
    canton: '',
    district: '',
    neighborhood: '',
    address: 'Dirección',
    cellPhoneNumber: '89717671',
    email: 'eortiza@lafise.com',

    nationality: '',
    sex: '',
    profession: '',
    company: '',
    companyPhone: '',
    monthlyIncome: '',
    originFunds: '',
    originFundsExplained: '',

    //STEP2
    plan: '',
    currency: '',
    nQuotas: '',
    nCoverage: {} as ICoveragesPlan,
    lstPlanConfig: [],
    planSelected: '',

    catQuotas: [],
    catProvince: [],
    catCanton: [],
    catDistrict: [],
    catNeighborhood: [],
    catNationality: [],
    catProfession: [],
    catOriginFunds: [],
    catCountry: [],
    catBank: [],
    catInvalidRequirements: [],
    planConfig: {} as IPlanConfig,
    catCoverages: [],
    lstRateResumen: [],
    lstRate: [],
    lstBeneficiary: GetLstBeneficiaryTest(),

    feePay: '',
    cardName: '',
    cardNumber: '',
    cardExpirationDate: '',
    cardCVV: '',


    acceptTerms: false,
    acceptTermsPV: false,
    acceptTermsFinish: false,

    statusAccount: '',
    transactionId: '',
    cnpoliza: '',

    acceptSaveCard: '',
    cardType: '',
    cardCountry: '',
    issuingBank: '',
    acceptCardTerm: false,

    polizaid: '507261',
    dateEnd: undefined,
    dateInit: undefined,
    oportunity: '123',
    oportunityCreated: undefined,
    errorRate: false,
    messageErrorRate: '',

    paymentPV: () => { },
    downloadPolicy: () => { },
    finish: () => { },
    downloadReceipts: () => { },
    viewFinishPage: () => { },
}



const setObj = () => (setData && isDevelopment) ? ({ ...VidaWithDataTemp }) : ({ ...VidaDataTemp });

const VidaDefault: IVidaCR = setObj();


export { VidaDefault, SiteConfig }